import { FC } from 'react';
import { Tab, TabProps } from '@chakra-ui/react';

const MhyTab: FC<TabProps> = (rops) => (
  <Tab
    fontWeight="500"
    textStyle="lg"
    px={0}
    pb={3}
    mr={9}
    mb="0"
    borderBottom="4px solid transparent"
    _selected={{
      borderColor: 'highlightColor',
    }}
    {...rops}
  />
);

export default MhyTab;
